"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useIntl } from "@amazeelabs/react-intl";
import { Dialog, DialogPanel, Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React, { createContext } from "react";
var MobileMenuContext = /*#__PURE__*/ createContext({
    isOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setIsOpen: function(isOpen) {}
});
export function MobileMenuProvider(param) {
    var children = param.children;
    var _React_useState = _sliced_to_array(React.useState(false), 2), isOpen = _React_useState[0], setIsOpen = _React_useState[1];
    return /*#__PURE__*/ React.createElement(MobileMenuContext.Provider, {
        value: {
            isOpen: isOpen,
            setIsOpen: setIsOpen
        }
    }, children);
}
export function MobileMenuButton(props) {
    var _React_useContext = React.useContext(MobileMenuContext), isOpen = _React_useContext.isOpen, setIsOpen = _React_useContext.setIsOpen;
    var intl = useIntl();
    return /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: props.className,
        onClick: function() {
            return setIsOpen(!isOpen);
        },
        "aria-label": intl.formatMessage({
            defaultMessage: "Open main navigation",
            id: "e7yFQY"
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, intl.formatMessage({
        defaultMessage: "Open main navigation",
        id: "e7yFQY"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "lg:flex lg:gap-x-3 lg:items-center text-theme-light hover:text-tcs-yellow transition-colors duration-200"
    }, /*#__PURE__*/ React.createElement(HamburgerLogo, null), " ", /*#__PURE__*/ React.createElement("span", {
        className: "hidden lg:block"
    }, intl.formatMessage({
        defaultMessage: "Menu",
        id: "tKMlOc"
    }))));
}
export function MobileMenu(param) {
    var children = param.children;
    var _React_useContext = React.useContext(MobileMenuContext), isOpen = _React_useContext.isOpen, setIsOpen = _React_useContext.setIsOpen;
    var intl = useIntl();
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: isOpen,
        onClose: setIsOpen,
        className: "block"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 z-50 duration-100 ease-out bg-black/30 "
    }), /*#__PURE__*/ React.createElement(DialogPanel, {
        transition: true,
        className: "fixed inset-y-0 right-0 w-full overflow-y-auto bg-theme-dark text-theme-light py-10 sm:max-w-lg md:max-w-xl z-50 transition-all duration-300 ease-out data-[closed]:translate-x-full"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "block absolute right-5 top-8 sm:top-[3.875rem] md:right-10 text-white hover:text-tcs-yellow transition-colors duration-200",
        onClick: function() {
            return setIsOpen(false);
        },
        "aria-label": intl.formatMessage({
            defaultMessage: "Close main navigation",
            id: "uC/cuK"
        })
    }, /*#__PURE__*/ React.createElement(XMarkIcon, {
        className: "h-8 w-8",
        "aria-hidden": "true"
    })), children));
}
export function MobileMenuLink(param) {
    var title = param.title, href = param.href;
    return /*#__PURE__*/ React.createElement(DisclosureButton, {
        as: "a",
        href: href,
        className: "block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-gray-900 hover:bg-gray-50"
    }, title);
}
export function MobileMenuDropdown(param) {
    var title = param.title, children = param.children, nestLevel = param.nestLevel;
    return /*#__PURE__*/ React.createElement(Disclosure, {
        as: "div",
        className: ""
    }, function(param) {
        var open = param.open;
        return /*#__PURE__*/ React.createElement("div", {
            className: clsx("", open && nestLevel === 2 && "bg-gray-100 rounded mx-8")
        }, /*#__PURE__*/ React.createElement(DisclosureButton, {
            className: clsx("flex w-full items-center justify-between py-4 leading-[1.25rem]", open && "text-blue-600", !open && "text-gray-600", open && nestLevel === 1 && "bg-blue-100", !open && nestLevel === 1 && "border-b border-b-blue-100", nestLevel === 1 && "px-8 text-lg", !open && nestLevel === 2 && "px-10", open && nestLevel === 2 && "px-2")
        }, title, /*#__PURE__*/ React.createElement(ChevronDownIcon, {
            className: clsx("h-5 w-5 flex-none text-blue-600", {
                "rotate-180": open
            }),
            "aria-hidden": "true"
        })), /*#__PURE__*/ React.createElement(DisclosurePanel, {
            className: ""
        }, children));
    });
}
export function HamburgerLogo() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "29",
        height: "25",
        viewBox: "0 0 29 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("rect", {
        x: "0.805664",
        y: "21.5474",
        width: "27.6113",
        height: "2.5",
        rx: "1.25",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "0.805664",
        y: "11.1931",
        width: "24.1599",
        height: "2.5",
        rx: "1.25",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "0.805664",
        y: "0.838867",
        width: "27.6113",
        height: "2.5",
        rx: "1.25",
        fill: "currentColor"
    }));
}
